import { StandardCover } from 'types/Cover';

export const coverDescription = (cover: StandardCover): string | undefined =>
    cover.hideDescription ? undefined : cover.shortDescription || (cover.rawData as { tagline?: string })?.tagline;

export const coverChannelImage = (cover: StandardCover): string | undefined => cover.channelImage ?? cover.rawData?.channelImage;
